import { render, staticRenderFns } from "./RegistrationChips.vue?vue&type=template&id=1b61e722&scoped=true&"
import script from "./RegistrationChips.vue?vue&type=script&lang=js&"
export * from "./RegistrationChips.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationChips.vue?vue&type=style&index=0&id=1b61e722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b61e722",
  null
  
)

export default component.exports